module.exports = __webpack_public_path__ + "img/引导.fda9c792.png";